import loadable from '@loadable/component';

export const Routine = loadable(() => import('../Routine'));
